import { Radio } from '@mui/material';
import React from 'react';
import '../../Incentive.css'

/**
 * Single radio field
 * @param props 
 * @returns 
 */
function IncentiveRadioField(props: any) {
  const { label, description, checked, value, handleChange, name, disable = false } = props;

  return (
    <div
      className={`incentive-radio-field-wrapper ${checked ? 'incentive-radio-field-checked' : ''}`}
      onClick={(e) => !disable && handleChange(value)} // Disable click if disable is true
      style={{ cursor: disable ? 'not-allowed' : 'pointer' }} // Change cursor style when disabled
    >
      <div className={`incentive-radio-field-header-wrapper ${checked ? 'incentive-radio-field-checked' : ''}`}>
        <Radio
          checked={checked}
          onChange={() => !disable && handleChange(value)} // Prevent changing value if disable is true
          value={value}
          name={name}
          style={{ padding: 0 }}
          disabled={disable} // Disable the radio button when disable is true
          sx={{
            color: 'var(--dashboard-secondary-color)',
            '&.Mui-checked': {
              color: 'var(--dashboard-secondary-color)',
            },
          }}
        />
        <span
          className={`incentive-radio-field-header-text ${checked ? 'incentive-radio-field-checked' : ''}`}
          style={{ color: disable ? 'grey' : 'inherit' }} // Change text color when disabled
        >
          {label}
        </span>
      </div>
      {
        description &&
        <div className="incentive-radio-field-description-wrapper">
          <p>{description}</p>
        </div>
      }
    </div>
  );
}

export default IncentiveRadioField;
